const MAX_RETRIES = 3;
const RETRY_DELAYS = [1000, 2000, 4000];
const STORYBLOK_CDN = 'a.storyblok.com';

/**
 * Append Storyblok image service transform to resize images.
 * Only applies to Storyblok CDN URLs. Non-Storyblok URLs pass through unchanged.
 * @param {string} url - Image URL
 * @param {number} width - Target width (0 = auto)
 * @returns {string} Optimized URL
 */
export function optimizeStoryblokImage(url, width = 640) {
  if (!url || !url.includes(STORYBLOK_CDN)) return url;
  if (url.includes('/m/')) return url;
  return `${url}/m/${width}x0/filters:autorotate()`;
}

/**
 * Resolve a Storyblok filename to a full URL.
 * Absolute URLs pass through; relative paths get the CDN prefix.
 * @param {string} filename
 * @returns {string}
 */
export function resolveStoryblokUrl(filename) {
  if (!filename) return '';
  return filename.startsWith('http') ? filename : `https://${STORYBLOK_CDN}${filename}`;
}

/**
 * Retry loading a failed image by appending a cache-busting parameter.
 * Returns the new URL to try, or null if max retries exceeded.
 * @param {string} originalUrl - The original image URL
 * @param {number} attempt - Current retry attempt (1-based)
 * @returns {{ url: string, delay: number } | null}
 */
export function getRetryUrl(originalUrl, attempt) {
  if (!originalUrl || attempt > MAX_RETRIES) return null;
  const base = originalUrl.replace(/([?&])_retry=\d+/, '$1').replace(/[?&]$/, '');
  const separator = base.includes('?') ? '&' : '?';
  return {
    url: `${base}${separator}_retry=${Date.now()}`,
    delay: RETRY_DELAYS[attempt - 1] || 2000,
  };
}
